/*
  Zdravi Stapala product card: quick add (style guide v3, step 4).

  - Heart: the card uses the theme's own <hdt-wishlist> button, so nothing
    for it lives here.
  - Cart circle: products with several sizes open a sheet (a centered dialog on
    desktop); one-size products are added straight away. No size is pre-selected
    unless only one size is in stock. Adding never reloads the page.
  - window.ZSCart is shared with the product page's "Додај во кошничка".
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = root + 'cart';
  var SIZE_GUIDE_URL = '/pages/vodic-za-golemini';

  /* ---------- Helpers ---------- */
  function money(cents) {
    var den = Math.floor(cents / 100);
    var thousands = Math.floor(den / 1000);
    var text = thousands ? thousands + '.' + String(den % 1000).padStart(3, '0') : String(den);
    return text + ' ден';
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function readJson(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Грешка при додавање.');
      return data;
    });
  }

  /* ---------- Cart API shared with the product page ---------- */
  var ZSCart = window.ZSCart = window.ZSCart || {};

  // Step 39 (owner): after an add, the cart drawer slides in instead of a message.
  // On the cart page the page itself shows the cart, so there the old message stays.
  function cartDrawer() {
    if (document.querySelector('.hdt-page-cart')) return null;
    var drawer = document.querySelector('hdt-cart-drawer[section-id]');
    return drawer && typeof drawer.open === 'function' ? drawer : null;
  }

  ZSCart.add = function (variantId, quantity) {
    var drawer = cartDrawer();
    var body = { items: [{ id: Number(variantId), quantity: quantity || 1 }] };
    // Ask for the drawer's fresh HTML in the same request (Shopify bundled section rendering).
    if (drawer) { body.sections = drawer.getAttribute('section-id'); body.sections_url = window.location.pathname; }
    ZSCart.lastAdd = null;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(readJson).then(function (data) {
      ZSCart.lastAdd = data;
      return data;
    });
  };

  // The theme's drawer renders the returned section and opens itself when the source is its own
  // add-to-cart form ('product-form-component' + 'open_cart_drawer'). Returns false when it can't.
  ZSCart.openDrawer = function () {
    var drawer = cartDrawer();
    var data = ZSCart.lastAdd;
    if (!drawer || !data || !data.sections || !data.sections[drawer.getAttribute('section-id')]) return false;
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: { cartData: data, source: 'product-form-component', actionAfterATC: 'open_cart_drawer' }
    }));
    fetchCart().then(paintCartExtras).catch(function () {});
    return true;
  };

  // Free-delivery bars and the drawer count (step 9). The theme refreshes the
  // drawer's items and subtotal itself; these parts are updated here.
  function paintCartExtras(cart) {
    var shipping = cart.items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    document.querySelectorAll('[data-zs-ship]').forEach(function (bar) {
      var threshold = Number(bar.getAttribute('data-threshold')) || 300000;
      var left = threshold - shipping;
      bar.hidden = cart.item_count === 0;
      bar.classList.toggle('is-done', left <= 0);
      var leftEl = bar.querySelector('[data-zs-ship-left]');
      if (leftEl) leftEl.textContent = money(Math.max(left, 0));
      var fill = bar.querySelector('[data-zs-ship-bar]');
      if (fill) fill.style.width = Math.min(100, Math.floor(shipping * 100 / threshold)) + '%';
    });
    document.querySelectorAll('.zs-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Header count, bottom bar count and cart drawer all listen to these theme events.
  ZSCart.refresh = function () {
    return fetchCart()
      .then(function (cart) {
        document.querySelectorAll('hdt-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: cart.item_count, total_price: cart.total_price } }));
        document.dispatchEvent(new CustomEvent('cart:reload'));
        paintCartExtras(cart);
        return cart;
      })
      .catch(function () {});
  };

  // Quantity and remove buttons in the drawer / cart page are the theme's own.
  // When the shown subtotal changes, re-read the cart and update the extras.
  var lastSubtotal = null;
  var cartWatchReady = false;
  function subtotalText() {
    var el = document.querySelector('#CartDrawer .hdt-mini-cart__value, .hdt-page-cart .hdt-totals__total-value');
    return el ? el.textContent.trim() : '';
  }
  function checkCartChange() {
    var now = subtotalText();
    if (!cartWatchReady) { cartWatchReady = true; lastSubtotal = now; return; }
    if (now === lastSubtotal) return;
    lastSubtotal = now;
    fetchCart().then(paintCartExtras).catch(function () {});
  }

  var toastTimer = null;
  ZSCart.toast = function (html, isError) {
    var toast = document.querySelector('.zs-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'zs-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      // A popover sits in the top layer, so it also shows above the open cart drawer.
      if (toast.showPopover) toast.setAttribute('popover', 'manual');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('is-error', !!isError);
    toast.innerHTML = html;
    if (toast.showPopover) {
      try { if (!toast.matches(':popover-open')) toast.showPopover(); } catch (err) {}
    }
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        if (toast.hidePopover && !toast.classList.contains('is-visible')) {
          try { toast.hidePopover(); } catch (err) {}
        }
      }, 250);
    }, isError ? 6000 : 4500);
  };

  // Confirmation used by one-size cards and the product page.
  ZSCart.confirm = function (sizeLabel) {
    if (ZSCart.openDrawer()) return;
    ZSCart.refresh();
    ZSCart.toast(
      '<span class="zs-toast__check" aria-hidden="true">✓</span>' +
      '<span class="zs-toast__text">Додадено во кошничка' + (sizeLabel ? ' · Број ' + esc(sizeLabel) : '') + '</span>' +
      '<a class="zs-toast__link" href="' + CART_URL + '">Кон кошничка</a>'
    );
  };

  /* ---------- Quick-add sheet ---------- */
  var productCache = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(readJson)
        .catch(function (err) { delete productCache[handle]; throw err; });
    }
    return productCache[handle];
  }

  var sheet = null;
  var lastTrigger = null;
  var state = null;

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function buildSheet() {
    // A native <dialog>: shown with showModal() it sits in the top layer,
    // so it also opens above the cart drawer (itself a modal dialog).
    sheet = document.createElement('dialog');
    sheet.className = 'zs-qa';
    sheet.setAttribute('aria-labelledby', 'zsQaTitle');
    sheet.innerHTML =
      '<div class="zs-qa__backdrop" data-zs-qa-close></div>' +
      '<div class="zs-qa__panel" tabindex="-1">' +
        '<div class="zs-qa__handle" aria-hidden="true"></div>' +
        '<button type="button" class="zs-qa__x" data-zs-qa-close aria-label="Затвори">' + ICON_X + '</button>' +
        '<div class="zs-qa__body"></div>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-zs-qa-close]')) { closeSheet(); return; }
      var size = event.target.closest('.zs-qa__size');
      if (size && !size.disabled) { pickSize(size); return; }
      if (event.target.closest('.zs-qa__add')) addFromSheet();
    });
    sheet.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeSheet();
    });
    sheet.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closeSheet(); return; }
      if (event.key === 'Tab') trapFocus(event);
      if (/^Arrow(Left|Right|Up|Down)$/.test(event.key) && event.target.classList.contains('zs-qa__size')) moveSize(event);
    });
    enableSwipe(sheet.querySelector('.zs-qa__panel'));
  }

  function render(product, handle, cardBrand) {
    var variants = product.variants || [];
    // Step 37: the card passes the real brand (from the brand tag); the shop's own name is never shown as a brand.
    var brand = cardBrand || (product.vendor && product.vendor !== 'Zdravi Stapala' ? product.vendor : '');
    var available = variants.filter(function (v) { return v.available; });
    var autoPick = available.length === 1 ? available[0] : null;
    var url = product.url || (root + 'products/' + handle);
    var image = product.featured_image ? sized(product.featured_image, 200) : '';
    var onSale = product.compare_at_price > product.price;

    var sizes = variants.map(function (v) {
      var picked = autoPick && autoPick.id === v.id;
      return '<button type="button" class="zs-qa__size' + (v.available ? '' : ' is-off') + (picked ? ' is-picked' : '') + '"' +
        ' role="radio" aria-checked="' + (picked ? 'true' : 'false') + '"' +
        (v.available ? '' : ' disabled aria-label="' + esc(v.option1 || v.title) + ' - распродадено"') +
        ' tabindex="' + (picked || (!autoPick && v === available[0]) ? '0' : '-1') + '"' +
        ' data-variant="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">' +
        esc(v.option1 || v.title) + '</button>';
    }).join('');

    sheet.querySelector('.zs-qa__body').innerHTML =
      '<div class="zs-qa__product">' +
        (image ? '<img class="zs-qa__img" src="' + esc(image) + '" alt="" width="72" height="72">' : '<span class="zs-qa__img"></span>') +
        '<div class="zs-qa__meta">' +
          (brand ? '<div class="zs-qa__brand">' + esc(brand) + '</div>' : '') +
          '<div class="zs-qa__name" id="zsQaTitle">' + esc(product.title) + '</div>' +
          '<div class="zs-qa__price"><b data-zs-qa-now>' + (product.price_varies && !autoPick ? 'Од ' : '') + money(autoPick ? autoPick.price : product.price) + '</b>' +
            '<s data-zs-qa-was' + (onSale ? '' : ' hidden') + '>' + (onSale ? money(autoPick ? autoPick.compare_at_price : product.compare_at_price) : '') + '</s></div>' +
        '</div>' +
      '</div>' +
      '<div class="zs-qa__choose">' +
        '<div class="zs-qa__row"><span class="zs-qa__label" id="zsQaSizeLabel">Избери големина</span>' +
          '<a class="zs-qa__guide" href="' + SIZE_GUIDE_URL + '">Табела со големини</a></div>' +
        '<div class="zs-qa__sizes" role="radiogroup" aria-labelledby="zsQaSizeLabel">' + sizes + '</div>' +
        '<p class="zs-qa__error" role="alert" hidden></p>' +
        '<button type="button" class="zs-qa__add"' + (autoPick ? '' : ' aria-disabled="true"') + '>' +
          (autoPick ? 'Додај во кошничка' : 'Избери големина') + '</button>' +
        '<a class="zs-qa__details" href="' + esc(url) + '">Види детали за производот →</a>' +
      '</div>' +
      '<div class="zs-qa__done" role="status" hidden>' +
        '<p class="zs-qa__done-title"><span aria-hidden="true">✓</span> Додадено во кошничка</p>' +
        '<p class="zs-qa__done-size"></p>' +
        '<a class="zs-qa__cart" href="' + CART_URL + '">Кон кошничка</a>' +
        '<button type="button" class="zs-qa__continue" data-zs-qa-close>Продолжи со купување</button>' +
      '</div>';

    state = { product: product, variant: autoPick };
  }

  function pickSize(button) {
    sheet.querySelectorAll('.zs-qa__size').forEach(function (b) {
      var on = b === button;
      b.classList.toggle('is-picked', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    var variantId = Number(button.getAttribute('data-variant'));
    state.variant = state.product.variants.filter(function (v) { return v.id === variantId; })[0] || null;
    var now = sheet.querySelector('[data-zs-qa-now]');
    var was = sheet.querySelector('[data-zs-qa-was]');
    var price = Number(button.getAttribute('data-price'));
    var compare = Number(button.getAttribute('data-compare'));
    now.textContent = money(price);
    was.hidden = !(compare > price);
    was.textContent = compare > price ? money(compare) : '';
    var add = sheet.querySelector('.zs-qa__add');
    add.removeAttribute('aria-disabled');
    add.textContent = 'Додај во кошничка';
    sheet.querySelector('.zs-qa__error').hidden = true;
  }

  function moveSize(event) {
    var sizes = Array.prototype.slice.call(sheet.querySelectorAll('.zs-qa__size:not([disabled])'));
    var index = sizes.indexOf(event.target);
    if (index === -1) return;
    event.preventDefault();
    var step = /Right|Down/.test(event.key) ? 1 : -1;
    var next = sizes[(index + step + sizes.length) % sizes.length];
    next.focus();
    pickSize(next);
  }

  function addFromSheet() {
    var add = sheet.querySelector('.zs-qa__add');
    var error = sheet.querySelector('.zs-qa__error');
    if (!state || !state.variant) {
      var group = sheet.querySelector('.zs-qa__sizes');
      group.classList.remove('is-nudged');
      void group.offsetWidth;
      group.classList.add('is-nudged');
      var first = sheet.querySelector('.zs-qa__size:not([disabled])');
      if (first) first.focus();
      return;
    }
    if (add.classList.contains('is-busy')) return;
    add.classList.add('is-busy');
    add.textContent = 'Се додава…';
    ZSCart.add(state.variant.id, 1).then(function () {
      if (cartDrawer()) {
        // Close the size sheet first, then let the drawer slide in with the new item.
        closeSheet();
        setTimeout(function () { if (!ZSCart.openDrawer()) ZSCart.confirm(state.variant.option1 || state.variant.title); }, 240);
        return;
      }
      ZSCart.refresh();
      sheet.querySelector('.zs-qa__choose').hidden = true;
      var done = sheet.querySelector('.zs-qa__done');
      done.querySelector('.zs-qa__done-size').textContent = 'Број ' + (state.variant.option1 || state.variant.title);
      done.hidden = false;
      sheet.querySelector('.zs-qa__panel').focus({ preventScroll: true });
    }).catch(function (err) {
      error.textContent = err.message || 'Не можевме да го додадеме производот. Обидете се повторно.';
      error.hidden = false;
      add.textContent = 'Додај во кошничка';
    }).then(function () {
      add.classList.remove('is-busy');
    });
  }

  function openSheet(product, handle, trigger) {
    if (!sheet) buildSheet();
    render(product, handle, trigger && trigger.getAttribute('data-zs-brand'));
    lastTrigger = trigger;
    closing = false;
    if (!sheet.open) {
      if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    }
    document.documentElement.classList.add('zs-qa-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      var focusTarget = sheet.querySelector('.zs-qa__size.is-picked') || sheet.querySelector('.zs-qa__panel');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });
  }

  var closing = false;
  function closeSheet() {
    if (!sheet || !sheet.open || closing) return;
    closing = true;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('zs-qa-open');
    var panel = sheet.querySelector('.zs-qa__panel');
    panel.style.transform = '';
    setTimeout(function () {
      closing = false;
      if (sheet.classList.contains('is-open')) return;
      if (sheet.close) sheet.close(); else sheet.removeAttribute('open');
    }, 220);
    if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  function trapFocus(event) {
    var items = Array.prototype.slice.call(sheet.querySelectorAll('a[href], button:not([disabled])'))
      .filter(function (el) { return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1'; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function enableSwipe(panel) {
    var startY = null;
    var delta = 0;
    panel.addEventListener('touchstart', function (event) {
      if (panel.scrollTop > 0 || window.matchMedia('(min-width: 768px)').matches) return;
      startY = event.touches[0].clientY;
      delta = 0;
      panel.classList.add('is-dragging');
    }, { passive: true });
    panel.addEventListener('touchmove', function (event) {
      if (startY === null) return;
      delta = Math.max(0, event.touches[0].clientY - startY);
      panel.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (startY === null) return;
      panel.classList.remove('is-dragging');
      if (delta > 90) closeSheet();
      else panel.style.transform = '';
      startY = null;
    });
  }

  function quickAdd(trigger) {
    var handle = trigger.getAttribute('data-zs-quick-add');
    if (trigger.classList.contains('is-busy')) return;
    trigger.classList.add('is-busy');
    loadProduct(handle).then(function (product) {
      var variants = product.variants || [];
      if (variants.length === 1) {
        if (!variants[0].available) { window.location.href = trigger.getAttribute('href'); return; }
        return ZSCart.add(variants[0].id, 1).then(function () { ZSCart.confirm(''); });
      }
      openSheet(product, handle, trigger);
    }).catch(function (err) {
      ZSCart.toast(esc(err.message || 'Грешка. Обидете се повторно.'), true);
    }).then(function () {
      trigger.classList.remove('is-busy');
    });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-zs-quick-add]');
    if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      quickAdd(trigger);
    }
  });

  // The theme re-renders the cart count and drawer, so re-check after changes.
  var queued = false;
  function queuePaint() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; checkCartChange(); });
  }
  // Step 37: watch only the cart drawer and the cart page (watching the whole page cost time on every change).
  function watchCart() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length || mutations[i].type === 'characterData') { queuePaint(); return; }
      }
    });
    [document.getElementById('CartDrawer'), document.querySelector('.hdt-page-cart') ? document.getElementById('MainContent') : null]
      .forEach(function (target) { if (target) observer.observe(target, { childList: true, subtree: true, characterData: true }); });
  }
  document.addEventListener('cart:count:update', queuePaint);

  function init() { watchCart(); checkCartChange(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
